import FooterMenu from "./modules/FooterMenu.js";
import ApiService from "./serverConnection/ApiService.js";
import LoginMenu from "./modules/LoginMenu.js";
import CenterMenu from "./modules/CenterMenu.js";
import ProfileView from "./modules/centerMenuTab/profileView.js";
import Overlay from "./modules/Overlay.js";

class EventManager {
    /**
     * @author Corentin (ccharton) Charton
     * @description Initialize the Event Manager
     */
    constructor() {
        this.modules = {
            Overlay,
            FooterMenu,
            LoginMenu,
            CenterMenu,
            ProfileView
        }
        this.autorizedFunctions = {
            Overlay: new Set(['closeOverlay']),
            FooterMenu: new Set(['onlinePong', 'localPong', 'pacman', 'tetris']),
            LoginMenu: new Set(['chooseName']),
            CenterMenu: new Set(['showStatusPicker', 'setOnlineStatus', 'setAwayStatus', 'setBusyStatus', 'setOfflineStatus', 'disconnectUser', 'showStatView', 'showMatchView', 'showProfileView', 'switchOnlyTabView']),
            ProfileView: new Set(['editDisplayName', 'closePopup', 'focusPopupTextInput', 'clearPopupTextInput', 'applyDisplayNameModification'])
        }
        this.onClickBind = this.onClick.bind(this)

        this.initEvent()
    }

    /**
     * @author Corentin (ccharton) Charton
     * @description Initialize the event listener
     */
    initEvent() {
        window.addEventListener('click', this.onClickBind)
    }

    /**
     * @author Corentin (ccharton) Charton
     * @description Handle the click event and trigger the right action
     * @param event {MouseEvent} - The click event
     * @returns {Promise<void>}
     */
    async onClick(event) {
        try {
            const action = event.target.closest('[data-action]')?.dataset.action
            if (!action) {
                return
            }

            const module = event.target.closest('[data-module]')?.dataset.module
            if (!module) {
                return
            }

            const classPointer = this.modules[module]
            if (!classPointer) {
                return
            }

            const isAuthorized = this.autorizedFunctions[module]?.has(action)
            if (!isAuthorized) {
                return
            }

            await classPointer[action](event)

        } catch (error) {
            console.error(`[onClick] Uncaught error while executing action`, error)
        }
    }

}

export default new EventManager()